const e={duration:.3,delay:0,endDelay:0,repeat:0,easing:"ease"};export{e as defaults};
